import {} from '../types/addressTypes.types';
export const getHasAddress = (address) => {
    const hasValidLength = Object.keys(address).length > 1;
    const hasFilledValues = Object.values(address).filter((value) => Boolean(value)).length > 1;
    return hasValidLength && hasFilledValues;
};
